import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authRoutes } from './auth/auth.module';
import { AuthState } from './auth/model/auth-state';
import { standaloneRoutes } from './standalone.routes';
import { notificationRoutes } from './notification/notification.module';
import { GatewayErrorComponent } from './public/gateway-error/gateway-error.component';
import { NotFoundComponent } from './public/not-found/not-found.component';
import { EnvironmentName } from './shared/config';
import { getEnvironmentName } from './shared/utils/env-utils';

const routes: Routes = [
  { path: 'settings', redirectTo: 'contacts', pathMatch: 'full' },
  { path: AuthState.GATEWAY_ERROR, component: GatewayErrorComponent },
];

if (getEnvironmentName() === EnvironmentName.STANDALONE) {
  routes.push(...standaloneRoutes);
} else {
  routes.unshift(...notificationRoutes);
  routes.unshift(...authRoutes);
  routes.push(
    { path: '', pathMatch: 'full', redirectTo: 'loading' },
    { path: '**', component: NotFoundComponent },
  );
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
